var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFbFooter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    fill: "none",
    viewBox: "0 0 42 43",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.7,
    d: "M20.704 41.341c10.953 0 19.832-8.88 19.832-19.833S31.657 1.676 20.704 1.676.87 10.556.87 21.508c0 10.954 8.88 19.833 19.833 19.833Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.224 23.424.479-3.12h-2.994v-2.025c0-.853.418-1.685 1.759-1.685h1.361v-2.657s-1.235-.21-2.416-.21c-2.465 0-4.077 1.494-4.077 4.199v2.378h-2.74v3.12h2.74v7.542h3.373v-7.542z"
  })));
};
export default SvgFbFooter;